import type { Location } from 'history'
import { useBlockNavigation } from '@app/src/hooks/useBlockNavigation'
import React from 'react'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import Dialog from './Dialog'

interface RouteLeavingGuardProps {
  when?: boolean
  navigate: (path: string) => void
  shouldBlockNavigation: (location: Location) => boolean
  ignoreSearchParamChanges?: boolean
}

const RouteLeavingGuard: React.FC<RouteLeavingGuardProps> = ({
  when,
  navigate,
  shouldBlockNavigation,
  ignoreSearchParamChanges,
}) => {
  const { formatMessage } = useIntl()
  const currentLocation = useLocation()

  const { isBlocked, confirmNavigation, cancelNavigation } = useBlockNavigation(Boolean(when), {
    shouldBlockLocation: nextLocation => {
      if (ignoreSearchParamChanges && currentLocation.pathname === nextLocation.pathname) return false
      return shouldBlockNavigation(nextLocation)
    },
    navigate: location => navigate(`${location.pathname}${location.search}`),
  })

  return (
    <Dialog
      open={isBlocked}
      onClose={cancelNavigation}
      title={formatMessage({ id: 'routeLeavingGuard.title' })}
      content={formatMessage({ id: 'routeLeavingGuard.body' })}
      buttons={[
        {
          label: formatMessage({ id: 'routeLeavingGuard.confirmButton' }),
          variant: 'outlined',
          onClick: confirmNavigation,
        },
        {
          label: formatMessage({ id: 'routeLeavingGuard.cancelButton' }),
          variant: 'contained',
          onClick: cancelNavigation,
        },
      ]}
    />
  )
}
export default RouteLeavingGuard
